import React, { useState, useContext, useEffect } from 'react';
import ViewsContext from 'contexts/viewsContext';
import HourlyLaborChartGlance from './hourlyLaborChartGlance';
import HourlyLaborTableViewGlance from './hourlyLaborTableViewGlance';




export default function ToggleHourlyLaborGlance(props) {

    const { viewsState, setHourlyLaborToggleState } = useContext(ViewsContext);
    const [chartToggleClass, setChartToggleClass] = useState('');
    const [tableViewToggleClass, setTableViewToggleClass] = useState('');

    useEffect(() => {
        if (viewsState.chartsAndTableViewsConfigs.hourlyLaborToggleState === 'chart') {
            setTableViewToggleClass('togglable-hidden');
            setChartToggleClass('');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlyLaborToggleState === 'tableView') {
            setChartToggleClass('togglable-hidden');
            setTableViewToggleClass('');
        }

    }, [viewsState]);

    const changeView = () => {
        if (viewsState.chartsAndTableViewsConfigs.hourlyLaborToggleState === 'chart') {
            setHourlyLaborToggleState('tableView');
        }
        else if (viewsState.chartsAndTableViewsConfigs.hourlyLaborToggleState === 'tableView') {
            setHourlyLaborToggleState('chart');
        }
    };

    if (viewsState.chartsAndTableViewsConfigs.hourlyLaborToggleState === 'chart') {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlyLaborChartGlance data={props.data} viewState={chartToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }
    else {
        return (
            <>
                <div className='glance-holder col-12  col-md-6'>
                    <HourlyLaborTableViewGlance data={props.data} viewState={tableViewToggleClass} changeViewStateFn={changeView} />
                </div>
            </>
        );
    }

}

